import { CSSProperties } from '@stitches/react';

export const loaderStyles: CSSProperties = {
  height: '520px',
  padding: '24px',
};
